import '../scss/enquiry-industry.scss';
import { Enquiry } from './modules/enquiry';

const enquiryIndustry = document.querySelector('[id^="enquiryIndustry"]');

// Dynamic fields for Industry enquiry form
const industrySizeOfField = document.querySelector('[id*="sizeOfField"]');
const industryNewOrExistingBuilding = document.querySelector('[id*="newOrExistingBuilding"]');
const industryConstructionPlans = document.querySelector('[id*="constructionPlans"]');
const photoOfRoof = document.querySelector('[id*="photoOfRoof"]');
const photoOfHouse = document.querySelector('[id*="photoOfHouse"]');
const photoOfMeterBox = document.querySelector('[id*="photoOfMeterBox"]');
const photoOfPlaceForTech = document.querySelector('[id*="photoOfPlaceForTech"]');

// These also only trigger if 'Gebäude' in previous step
const industryRoofMaterial = document.querySelector('[id*="roofMaterial"]');
const industryStatics = document.querySelector('[id*="statics"]');
const industryLightningProtection = document.querySelector('[id*="lightningProtection"]');
const industryEnergyConsumption = document.querySelector('[id*="energyConsumption"]');
const industryTransformerStation = document.querySelector('[id*="transformerStationExists"]');
const industryTransformerStationPower = document.querySelector('[id*="transformerStationPower"]');
const industryTransformerStationDistance = document.querySelector('[id*="transformerStationDistance"]');
const industryFinancingOptions = document.querySelector('[id*="typeOfFinancing"]');
const personalRecommendation = document.querySelector('[id*="personalRecommendation"]');

// Field triggers for Industry enquiry form
const industryTypeOfProjectFreefield = document.querySelector('[id*="typeOfProject-0"]');
const industryTypeOfProjectBuilding = document.querySelector('[id*="typeOfProject-1"]');
const industryNewBuildingPlanned = document.querySelector('[id*="newOrExistingBuilding-0"]');
const industryExistingBuilding = document.querySelector('[id*="newOrExistingBuilding-1"]');
const industryHasLightningProtection = document.querySelector('[id*="lightningProtection-0"]');
const industryHasTransformerStation = document.querySelector('[id*="transformerStationExists-0"]');
const industryHasNoTransformerStation = document.querySelector('[id*="transformerStationExists-1"]');
const industryFinancing = document.querySelector('[id*="financing-0"]');
const foundUsOn = document.querySelector('[id*="foundUsOn"]');

if (enquiryIndustry) {
  new Enquiry().hideFieldsOnLoad([
    industrySizeOfField,
    industryNewOrExistingBuilding,
    industryConstructionPlans,
    photoOfHouse,
    photoOfRoof,
    photoOfMeterBox,
    photoOfPlaceForTech,
    industryRoofMaterial,
    industryStatics,
    industryLightningProtection,
    industryEnergyConsumption,
    industryTransformerStation,
    industryTransformerStationPower,
    industryTransformerStationDistance,
    industryFinancingOptions,
    personalRecommendation
  ]);

  new Enquiry().addSubmitEventHandler(enquiryIndustry);

  if (industryTypeOfProjectFreefield || industryTypeOfProjectBuilding) {
    new Enquiry().toggleField(
      [industryTypeOfProjectFreefield, industryTypeOfProjectBuilding],
      () => {
        const isFreefield = industryTypeOfProjectFreefield.checked;
        const isBuilding = industryTypeOfProjectBuilding.checked;

        new Enquiry().handleFieldDisplay(isFreefield, [industrySizeOfField], [industryNewOrExistingBuilding]);
        new Enquiry().handleFieldDisplay(isBuilding, [industryNewOrExistingBuilding], [industrySizeOfField]);

        // We need that info in the next step (will be deleted after completion).
        window.localStorage.setItem('industryEnquiryProjectType', (isFreefield) ? 'field' : 'building');
      }
    );

    if (industryNewBuildingPlanned || industryExistingBuilding) {
      new Enquiry().toggleField(
        [industryNewBuildingPlanned, industryExistingBuilding],
        () => {
          const isPlanned = industryNewBuildingPlanned.checked;
          const isExisting = industryExistingBuilding.checked;

          new Enquiry().handleFieldDisplay(isPlanned, [industryConstructionPlans], [photoOfHouse, photoOfMeterBox, photoOfPlaceForTech, photoOfRoof]);
          new Enquiry().handleFieldDisplay(isExisting, [photoOfHouse, photoOfMeterBox, photoOfPlaceForTech, photoOfRoof], [industryConstructionPlans]);
        }
      );
    }
  }

  if (window.localStorage.getItem('industryEnquiryProjectType') === 'building') {
    new Enquiry().showFields([
      industryRoofMaterial,
      industryStatics,
      industryLightningProtection
    ]);

    if (industryLightningProtection) {
      new Enquiry().toggleField(
        [industryHasLightningProtection],
        () => {
          new Enquiry().handleFieldDisplay(industryHasLightningProtection.checked, [industryEnergyConsumption, industryTransformerStation]);
        }
      );
    }

    if (industryTransformerStation) {
      new Enquiry().toggleField(
        [industryHasTransformerStation, industryHasNoTransformerStation],
        () => {
          const hasTransformer = industryHasTransformerStation.checked;
          const hasNoTransformer = industryHasNoTransformerStation.checked;

          new Enquiry().handleFieldDisplay(hasTransformer, [industryTransformerStationPower], [industryTransformerStationDistance]);
          new Enquiry().handleFieldDisplay(hasNoTransformer, [industryTransformerStationDistance], [industryTransformerStationPower]);
        }
      );
    }
  }

  if (industryFinancing) {
    new Enquiry().toggleField(
      [industryFinancing],
      () => {
        new Enquiry().handleFieldDisplay(industryFinancing.checked, [industryFinancingOptions]);
      }
    );
  }

  if (foundUsOn) {
    new Enquiry().toggleField(
      [foundUsOn],
      () => {
        new Enquiry().handleFieldDisplay(foundUsOn.value === 'personalRecommendation', [
          personalRecommendation
        ]);
      });
  }

  if (window.localStorage.getItem('industryEnquiryProjectType')) {
    window.localStorage.removeItem('industryEnquiryProjectType');
  }
}
